<template>
  <v-row dense>
    <v-col cols="6" v-for="(value, shardTitle) in filteredInfo" :key="shardTitle">
      <v-text-field
        :value="value"
        :label="shardTitle"
        placeholder=" "
        disabled
        dense
        hide-details
      />
    </v-col>
  </v-row>
</template>

<script>
  export default {
    name: "DynamicFormArithmetic",
    props: {
      info: Object,
    },
    computed: {
      filteredInfo() {
        if (this.info) {
          delete this.info["client_mutation_id"];
          return this.info;
        }

        return this.info;
      },
    },
  };
</script>

<style lang="scss" scoped></style>
